import AuthenticatorIcon from '../../../../../assets/icons/channel-authenticator.svg';
import EmailIcon from '../../../../../assets/icons/channel-email.svg';
import SmsIcon from '../../../../../assets/icons/channel-sms.svg';
import { TMfaType } from '../../../../../store/slices/security/mfaTypes';

export const channelMeta: Record<
  TMfaType,
  {
    label: string;
    pickerLabel: string;
    pickerDescription: string;
    description: string;
    icon: string;
    recommended?: boolean;
  }
> = {
  authenticator: {
    label: 'Authenticator App',
    pickerLabel: 'Authenticator App',
    pickerDescription: 'Validation will be done via an authenticator app.',
    description:
      'Use an authenticator app (e.g. Google Authenticator) to generate codes.',
    icon: AuthenticatorIcon,
    recommended: true,
  },
  email: {
    label: 'Email',
    pickerLabel: 'Email',
    pickerDescription: 'One Time Password will be sent to valid email.',
    description: 'Receive a 6-digit code via email.',
    icon: EmailIcon,
  },
  sms: {
    label: 'SMS',
    pickerLabel: 'SMS',
    pickerDescription: 'One Time Password will be sent to valid number.',
    description: 'Receive a 6-digit code via text message.',
    icon: SmsIcon,
  },
};

export const channelOrder: TMfaType[] = ['authenticator', 'email', 'sms'];
